import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { environment } from "../../../../environments/environment";
import { IEmployeeComplainRepository } from "./IEmployeeComplainRepository";
import { EmployeeComplains } from "src/app/models/HR/EmployeeComplains/employeeComplain";

@Injectable()
export class EmployeeComplainRepository extends GenericRepository<EmployeeComplains> implements IEmployeeComplainRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/EmployeeComplains', environment.urlAddress);
    }
    GetAll(currentPage: number, recordsPerPage: number, filterText: string, completed: number): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }

        return this.Get('SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText + '/' + completed)
    }
    UpdateStatus(item: any): Observable<ResponseModel> {
        return this.PostData('/UpdateStatus', item).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.GetById('/NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadRec(Id: number): Observable<ResponseModel> {
        const url = `/GetRec/${Id}`;
        return this.GetById(url)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    GetStatusHistory(id: number): Observable<any> {
        return this.GetById(`/GetStatusHistory?id=${id}`)
            .pipe(map(this.extractData), catchError(this.handleError));
    }
}